import React, { useState } from "react";
import styled from "@emotion/styled";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

import TimeSlider from "components/TimeSlider";
import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  margin-top: ${ParkkiTheme.spacings.tiny};
  min-width: 320px;
  max-width: 320px;
`;

type Props = {
  duration: number;
  label: string;
  onSubmit: Function;
};

function TimeInput({ duration, label, onSubmit }: Props): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);

  function openDialog() {
    setDialogOpen(true);
  }

  function hideDialog() {
    setDialogOpen(false);
  }

  return (
    <Container>
      <TimeSlider
        // @ts-ignore
        fullWidth
        floatingLabel={label}
        onSubmit={onSubmit}
        duration={duration}
        timeSliderDialogOpen={dialogOpen}
        showDialog={openDialog}
        hideDialog={hideDialog}
      />

      <div>
        <IconButton onClick={openDialog}>
          <EditIcon />
        </IconButton>
      </div>
    </Container>
  );
}

export default TimeInput;
